import { useMemo } from "react";
import { useStores } from "../../../stores/setup/use-store";
import { AlertChannel } from "../types";

interface UseUserSelectionPermissionsParams {
	channels?: AlertChannel[];
}

export function useUserSelectionPermissions({
	channels,
}: UseUserSelectionPermissionsParams) {
	const {
		dataStores: { authStore },
	} = useStores();

	const isUserSelectionDisabled = useMemo(() => {
		const hasSpecialPermission = authStore.adminUser || authStore.superUser;

		if (!hasSpecialPermission) {
			return true;
		}

		const selectedChannels = channels || [];
		const hasWhatsapp = selectedChannels.includes("whatsapp");
		const hasEmail = selectedChannels.includes("email");
		const hasPush = selectedChannels.includes("push_notification");

		return !hasWhatsapp && !hasEmail && !hasPush;
	}, [authStore.adminUser, authStore.superUser, channels]);

	return {
		isUserSelectionDisabled,
		hasSpecialPermission: authStore.adminUser || authStore.superUser,
	};
}
